import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetTrigger } from './ui/sheet';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';

export const MobileNav = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          data-testid="mobile-menu-button"
          className="lg:hidden fixed top-4 left-4 z-50 p-3 bg-[#121212] border border-[#27272A] hover:border-[#FF9900] transition-colors"
        >
          <Menu className="w-6 h-6 text-[#FF9900]" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-[280px] bg-[#121212] border-[#27272A]">
        <SheetHeader className="sr-only">
          <SheetTitle>Navigation Menu</SheetTitle>
          <SheetDescription>Main navigation links for Eastend Iron Industries</SheetDescription>
        </SheetHeader>
        <Sidebar isOpen={open} onClose={() => setOpen(false)} />
      </SheetContent>
    </Sheet>
  );
};

export default MobileNav;